import {
  Box,
  ComponentMultiStyleConfig,
  Radio,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";

export type CMFrameRadioLinkageProps = {
  /**
   * ラジオボタンの表示ラベル
   */
  label?: string;

  /**
   * ラジオ連携フレームのラジオボタンの表示制御に使用する。
   */
  isDisabled?: boolean;

  /**
   * ラジオ連携フレームのラジオボタンの表示制御に使用する。
   */
  key?: string;

  /**
   * ラジオ連携フレームのラジオボタンの表示制御に使用する。
   */
  value?: string;

  /**
   * 追加入力用の別コンポーネントを受け取り、入力エリアとして表示
   */
  children?: ReactNode;

  /**
   * 追加入力項目の表示制御に使用
   */
  isSelected: boolean;
} & ComponentStyleProps;

/**
 * ラジオ連携フレームコンポーネント.
 */
export const CMFrameRadioLinkage = ({
  label,
  children,
  isSelected,

  key,
  value,

  sx,
  ...rest
}: CMFrameRadioLinkageProps) => {
  const styles = useMultiStyleConfig("CMFrameRadioLinkageStyles", {});

  return (
    <Box {...rest} sx={{ ...styles.container, ...sx }}>
      <Radio key={key} value={value} sx={{ ...styles.radio }}>
        <Text sx={styles.label}>{label}</Text>
      </Radio>
      {isSelected ? <Box sx={styles.children}>{children}</Box> : undefined}
    </Box>
  );
};

export const CMFrameRadioLinkageStyles: ComponentMultiStyleConfig = {
  parts: ["container", "radio", "box", "label", "children"],
  baseStyle: {
    container: {},
    radio: {},
    label: { h: "24px", lineHeight: "24px" },
    children: { ml: "30px", mt: "8px", bg: "white" },
  },
};
